import React from 'react'
import { Link } from 'react-router-dom'
import socialLinks from '../../config/socialLinks'

export default function Top() {
    return (
        <>
            {/* Topbar Start - Logo + Ticker + Socials */}
            <div className="container-fluid py-2 bg-light site-topbar">
                <div className="container">
                    <div className="d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                            <Link to="/" className="d-flex align-items-center text-decoration-none">
                                <img src="/img/logo.webp" alt="100Eyes" style={{ width: '100%', maxWidth: '200px', minWidth: '120px', height: 'auto' }} className="responsive-logo" />
                                
                            </Link>
                               {/* <div className="ms-2">
                                    <div className="fw-bold fs-2">100Eyes Technologies LLP</div>
                                    <small className="text-muted">Digital Solutions</small>
                                </div> */}
                           
                            
                        </div>
                        <div className="d-flex align-items-center">
                            <a className="me-3 text-dark" href={socialLinks.facebook} target="_blank" rel="noopener noreferrer" aria-label="facebook"><i className="fab fa-facebook-f" /></a>
                            <a className="me-3 text-dark" href={socialLinks.twitter} target="_blank" rel="noopener noreferrer" aria-label="twitter"><i className="fab fa-twitter" /></a>
                            <a className="me-3 text-dark" href={socialLinks.linkedin} target="_blank" rel="noopener noreferrer" aria-label="linkedin"><i className="fab fa-linkedin-in" /></a>
                            <a className="text-dark" href={socialLinks.instagram} target="_blank" rel="noopener noreferrer" aria-label="instagram"><i className="fab fa-instagram" /></a>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
